import { render, staticRenderFns } from "./RoleDataruleModal.vue?vue&type=template&id=5fa38486&scoped=true&"
import script from "./RoleDataruleModal.vue?vue&type=script&lang=js&"
export * from "./RoleDataruleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa38486",
  null
  
)

export default component.exports